import { PlaceShort } from 'src/api/places';
import { PlaceWithStatus } from 'src/api/plan';
import { BookingObject, ParkingBookingData, PlaceType } from 'src/types';

export const isPlaceWithStatus = (
  place: PlaceShort | PlaceWithStatus,
): place is PlaceWithStatus => 'placeCurrentStatus' in place;

export const toBookingObject = (
  place: PlaceShort | PlaceWithStatus,
): BookingObject => {
  const geometry = JSON.parse(place.planGeometry);
  const hasStatus = isPlaceWithStatus(place);
  const status = hasStatus ? place.placeCurrentStatus : null;

  switch (place.typeId) {
    case PlaceType.Desk:
      return {
        id: place.placeId,
        mapPlaceId: String(place.placeId),
        type: place.typeId,
        x: geometry.x,
        y: geometry.y,
        width: geometry.width,
        height: geometry.height,
        rotation: geometry.rotation,
        fontSize: geometry.fontSize,
        title: place.title,
        status,
        byWindow: hasStatus ? place.byWindow : undefined,
        withMonitor: hasStatus ? place.withMonitor : undefined,
        withCharger: hasStatus ? place.withCharger : undefined,
        withDivider: hasStatus ? place.withDivider : undefined,
        spaceId: place.spaceId,
        responsible: hasStatus ? null : place.responsible,
        responsibleEmployeeNumber: hasStatus
          ? place.responsible
          : (place.responsible?.employeeNumber ?? null),
      };
    case PlaceType.Room:
      return {
        id: place.placeId,
        mapPlaceId: String(place.placeId),
        type: place.typeId,
        x: geometry.x,
        y: geometry.y,
        width: geometry.width,
        height: geometry.height,
        fontSize: geometry.fontSize,
        title: place.title,
        status,
        seatCount: place.seatCount,
        roomType: place.roomTypeId,
        withTv: hasStatus ? place.withTv : undefined,
        withVideoCalls: hasStatus ? place.withVideoCalls : undefined,
        withFlipChart: hasStatus ? place.withFlipChart : undefined,
        withWater: hasStatus ? place.withWater : undefined,
        spaceId: place.spaceId,
      };
    case PlaceType.Parking:
      return {
        id: place.placeId,
        mapPlaceId: String(place.placeId),
        type: place.typeId,
        x: geometry.x,
        y: geometry.y,
        width: geometry.width,
        height: geometry.height,
        fontSize: geometry.fontSize,
        title: place.title,
        status: status as ParkingBookingData,
        guest: place.guest,
        spaceId: place.spaceId,
        responsible: hasStatus ? null : place.responsible,
        responsibleEmployeeNumber: hasStatus
          ? place.responsible
          : (place.responsible?.employeeNumber ?? null),
        shared: hasStatus ? place.shared : false,
        rotation: geometry.rotation,
        spaceAdministrator: hasStatus
          ? (place.spaceAdministrator ?? undefined)
          : undefined,
      };
  }
};
